export default __webpack_public_path__ + "static/media/GOKIDZ_LOGO_CMYK.a9e014f5.png";